<div class="row">
  <div class="col-md-4 col-sm-3"></div>
  <div class="col-md-4 col-sm-6">
    <div class="row dv-bsnss" *ngIf="userExist">
      <div class="col-sm-6 img-area">
        <a href="" class="brand left-margin w-nav-brand">
          <img src="assets/img/Merch-Loop4.png" width="110"
            sizes="(max-width: 479px) 44vw, (max-width: 991px) 110px, 100vw"
            srcset="assets/img/Merch-Loop4-p-500.png 500w, assets/img/Merch-Loop4-p-800.png 800w, assets/img/Merch-Loop4-p-1080.png 1080w, assets/img/Merch-Loop4.png 1158w"
            alt="">
        </a>
      </div>
      <div class="col-sm-6">
        <p class="cmpny-name" *ngIf="company">Click on Accept to join {{company}}.</p>
        <p *ngIf="userExist && hasCompany">You are already a member of a company, do you want to override it?</p>
        <div *ngIf="userExist">
          <button (click)="acceptInvitation()" mat-raised-button color="accent">Accept</button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4 col-sm-3"></div>
</div>